// Imports
import ___CSS_LOADER_API_SOURCEMAP_IMPORT___ from "../node_modules/css-loader/dist/runtime/sourceMaps.js";
import ___CSS_LOADER_API_IMPORT___ from "../node_modules/css-loader/dist/runtime/api.js";
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
___CSS_LOADER_EXPORT___.push([module.id, "@import url(https://fonts.googleapis.com/css2?family=Poppins:ital,wght@0,100;0,200;0,300;0,400;0,500;0,600;0,700;0,800;0,900;1,100;1,200;1,300;1,400;1,500;1,600;1,700;1,800;1,900&display=swap);"]);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `*{
  box-sizing: border-box;
  margin: 0;
  padding: 0;
  font-family: 'Poppins', sans-serif;
  font-weight: 500;
  color: rgba(255, 255, 255, 0.8);
  text-decoration: none;
  scroll-behavior: smooth;
}

body {
  background: black;
  /* background: linear-gradient(109.6deg, rgba(0, 0, 0, 0.93) 11.2%, rgb(63, 61, 61) 78.9%); */
}

::-webkit-scrollbar {

  display: none;
}

ul {
  list-style: none;
}

.btn {
  display: flex;
  justify-content: center;
  align-items: center;
  border: 2px solid #F94892;
  width: fit-content;
  padding: 15px 25px;
  color: #fff;
  font-size: 20px;
  border-radius: 10px;
  position: relative;
  bottom: 0;
  margin-top: 50px;
  transition: all 0.35s ease-out;
  background-color: transparent;
}

.btn:hover {
  background-color: #F94892;
  bottom: 12px;
  box-shadow: 0 0 20px 1px rgba(205, 106, 139, 0.65);
}

.btn:active {
  background-color: rgb(141, 33, 78);
}

@media  screen and (max-width: 750px) {
  .btn {
    font-size: 16px;
  }
}`, "",{"version":3,"sources":["webpack://./src/index.css"],"names":[],"mappings":"AAEA;EACE,sBAAsB;EACtB,SAAS;EACT,UAAU;EACV,kCAAkC;EAClC,gBAAgB;EAChB,+BAA+B;EAC/B,qBAAqB;EACrB,uBAAuB;AACzB;;AAEA;EACE,iBAAiB;EACjB,6FAA6F;AAC/F;;AAEA;;EAEE,aAAa;AACf;;AAEA;EACE,gBAAgB;AAClB;;AAEA;EACE,aAAa;EACb,uBAAuB;EACvB,mBAAmB;EACnB,yBAAyB;EACzB,kBAAkB;EAClB,kBAAkB;EAClB,WAAW;EACX,eAAe;EACf,mBAAmB;EACnB,kBAAkB;EAClB,SAAS;EACT,gBAAgB;EAChB,8BAA8B;EAC9B,6BAA6B;AAC/B;;AAEA;EACE,yBAAyB;EACzB,YAAY;EACZ,kDAAkD;AACpD;;AAEA;EACE,kCAAkC;AACpC;;AAEA;EACE;IACE,eAAe;EACjB;AACF","sourcesContent":["@import url('https://fonts.googleapis.com/css2?family=Poppins:ital,wght@0,100;0,200;0,300;0,400;0,500;0,600;0,700;0,800;0,900;1,100;1,200;1,300;1,400;1,500;1,600;1,700;1,800;1,900&display=swap');\n\n*{\n  box-sizing: border-box;\n  margin: 0;\n  padding: 0;\n  font-family: 'Poppins', sans-serif;\n  font-weight: 500;\n  color: rgba(255, 255, 255, 0.8);\n  text-decoration: none;\n  scroll-behavior: smooth;\n}\n\nbody {\n  background: black;\n  /* background: linear-gradient(109.6deg, rgba(0, 0, 0, 0.93) 11.2%, rgb(63, 61, 61) 78.9%); */\n}\n\n::-webkit-scrollbar {\n\n  display: none;\n}\n\nul {\n  list-style: none;\n}\n\n.btn {\n  display: flex;\n  justify-content: center;\n  align-items: center;\n  border: 2px solid #F94892;\n  width: fit-content;\n  padding: 15px 25px;\n  color: #fff;\n  font-size: 20px;\n  border-radius: 10px;\n  position: relative;\n  bottom: 0;\n  margin-top: 50px;\n  transition: all 0.35s ease-out;\n  background-color: transparent;\n}\n\n.btn:hover {\n  background-color: #F94892;\n  bottom: 12px;\n  box-shadow: 0 0 20px 1px rgba(205, 106, 139, 0.65);\n}\n\n.btn:active {\n  background-color: rgb(141, 33, 78);\n}\n\n@media  screen and (max-width: 750px) {\n  .btn {\n    font-size: 16px;\n  }\n}"],"sourceRoot":""}]);
// Exports
___CSS_LOADER_EXPORT___.locals = {};
export default ___CSS_LOADER_EXPORT___;
